import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CreativeDetail } from '../creative-detail-v2/creative-detail.interface';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { ModalService } from '../../../shared/directives/modal/modal.service';

@Component({
	selector: 'app-marketron-display-creative',
	templateUrl: './marketron-display-creative.component.html',
	styleUrls: ['./marketron-display-creative.component.css']
})
export class MarketronDisplayCreativeComponent implements OnInit, AfterViewInit {
	@Input() creative: CreativeDetail;
	@Input() creativeIndex: number;
	@Output() previewCreativeEvent = new EventEmitter<number>();

	public shouldShow = true;
	public iframeUrl;
	public isSocial: Boolean;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true,
		allowTitleHTML: true
	};
	constructor(
		private analyticsDataModel: AnalyticsDataModel,
		private sanitizer: DomSanitizer,
		private modalService: ModalService
	) {}

	ngOnInit() {
		this.isSocial = this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
		if (this.creative.iframeUrl) {
			this.getAddIframeToDocument(this.creative.iframeUrl);
		}
	}

	ngAfterViewInit() {
		if (
			this.analyticsDataModel.getCurrentPath() === PATHS.GEOFENCE ||
			this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL
		) {
			this.shouldShow = false;
		}
	}

	openModal(creativeIndex: number) {
		this.previewCreativeEvent.emit(creativeIndex);
	}

	getAddIframeToDocument(iframe) {
		this.iframeUrl = this.sanitizer.bypassSecurityTrustHtml(iframe);
	}
}
